import React from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { colors, type, space, radius, motion } from '../tokens';

const ACTIONS = [
  { id: 'pause',    icon: 'pause',     label: 'Pause',         color: colors.warning },
  { id: 'upgrade',  icon: 'arrowup',   label: 'Upgrade',       color: colors.success },
  { id: 'downgrade',icon: 'arrowdown', label: 'Downgrade',     color: colors.info },
  { id: 'method',   icon: 'shield',    label: 'Change method', color: colors.textSecondary },
  { id: 'cancel',   icon: 'close',     label: 'Cancel',        color: colors.error },
];

const PauseUpgradePanel = ({ status = 'Active', onAction, disabledActions = [] }) => {
  const isPaused = status === 'Paused';
  return (
    <div style={{ display: 'flex', gap: space[2], flexWrap: 'wrap' }}>
      {ACTIONS.map(a => {
        let label = a.label;
        let iconName = a.icon;
        if (a.id === 'pause' && isPaused) { label = 'Resume'; iconName = 'play'; }
        const disabled = disabledActions.includes(a.id);
        return (
          <button
            key={a.id}
            onClick={() => !disabled && onAction && onAction(a.id)}
            disabled={disabled}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: space[2],
              padding: `${space[2]}px ${space[3]}px`,
              background: colors.surface,
              border: `1px solid ${colors.border}`,
              borderRadius: radius.sm,
              color: disabled ? colors.textTertiary : a.color,
              ...type.small,
              fontWeight: 700,
              fontFamily: 'inherit',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.5 : 1,
              transition: `all ${motion.fast}`,
            }}
            onMouseEnter={e => {
              if (disabled) return;
              e.currentTarget.style.borderColor = a.color;
              e.currentTarget.style.background = `${a.color}11`;
            }}
            onMouseLeave={e => {
              if (disabled) return;
              e.currentTarget.style.borderColor = colors.border;
              e.currentTarget.style.background = colors.surface;
            }}
          >
            <Icon category="utility" name={iconName} size="xx-small" style={{ fill: 'currentColor' }} />
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default PauseUpgradePanel;
